__turbopack_context__.v({
  "description": "twoFactorAuthenticationModal-module-scss-module__GSy-9q__description",
  "footer": "twoFactorAuthenticationModal-module-scss-module__GSy-9q__footer",
  "logo": "twoFactorAuthenticationModal-module-scss-module__GSy-9q__logo",
  "title": "twoFactorAuthenticationModal-module-scss-module__GSy-9q__title",
  "verificationModal": "twoFactorAuthenticationModal-module-scss-module__GSy-9q__verificationModal",
  "verificationModalContent": "twoFactorAuthenticationModal-module-scss-module__GSy-9q__verificationModalContent",
});
